export const DEFAULT_GROUP_ICON = 'folder-open';
export const DEFAULT_ACTION_ICON = 'db-run';
export const DEFAULT_DISPLAY_MODE_ICON = 'ui-tab';

export const OPEN_MENU_HOTKEY = 'Ctrl+Shift+M';

export const MENU_ROOT_ICON_CLASS = 'menu-root-icon';
